import type {AutomationMeta as AutomationMetaCore} from '@gongxigames/framework/core/fragments/Autotest';

export {AUTOMATION_META} from '@gongxigames/framework/core/fragments/Autotest';
export type {AutomationMetaAny} from '@gongxigames/framework/core/fragments/Autotest';

export type AutomationMetaSymbol = {
    type: 'reels_symbol';
    id: number;
    indexReel: number;
    indexSymbol: number;
};

export type AutomationMetaReel = {
    type: 'reels_symbol';
    id: number;
    indexReel: number;
    indexSymbol: number;
};

export type OddsPay = {
    type: 'odds_pay';
    symbol: number;
    payIndex: number;
    pay: number;
};

export type AutomationMeta = AutomationMetaCore
    | AutomationMetaSymbol
    | AutomationMetaReel;